import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import {showProject} from '../reducers/PortfolioReducer';

import '../../styles/elements/portfolioProject.css';
import SvgImageLoader from './SvgImageLoader';

class PortfolioProject extends Component {
  project = this.props.project;
  portfolio = null;

  generateUrl(slug) {
    return '/portfolio/' + slug;
  }

  render() {
    return (
      <div className={'portfolio-project' + (this.props.className ? ' ' + this.props.className : '') + (this.project.gradient ? ' portfolio-project--' + this.project.gradient : '')}>
        <div className="portfolio-project__container">
          <SvgImageLoader
            svg={this.project.images.background}
            image={this.project.img}
            className="portfolio-project__image"
            alt={this.project.name + ' background'}
          />
          <img className="portfolio-project__logo" src={this.project.logo} alt={this.project.name + ' logo'}/>
          <div className="portfolio-project__content">
            <div className="portfolio-project__info">{this.project.origin}</div>
            <div className="portfolio-project__solution">
              <h2 className="portfolio-project__name">{this.project.name}</h2>
              <Link className="portfolio-project__see" onClick={(e) => {
                return this.linkClicked(e)
              }} to={this.generateUrl(this.project.slug)}>See More</Link>
            </div>
            <div className="portfolio-project__tags">{
              this.project.tags.map((tag, i) => {
                return (<span className="portfolio-project__tag" key={'ppt' + i}>{tag}</span>)
              })
            }</div>
          </div>
        </div>
      </div>
    )
  }

  linkClicked(e) {
    return this.props.dispatch(showProject())
    //document.getElementsByClassName('layout-main__container')[0].scrollTop = 0;
  }


}

const mapStateToProps = state => {
  return {
    portfolio: state.portfolio,
  }
};

export default withRouter(connect(mapStateToProps)(PortfolioProject));


// WEBPACK FOOTER //
// ./src/js/elements/PortfolioProject.js